import type { HTMLAttributes, ReactNode } from 'react';

// UX-24 — première vraie utilisation de ce composant dans ce projet (confirmé
// absent de `packages/ui/src` avant ce ticket, comme demandé). Spécification
// verrouillée du design system : fond TEINTÉ selon le sens de la valeur
// affichée (`success` = va bien, `attention` = a besoin d'action, `neutral` =
// purement informatif), libellé en petites majuscules, valeur en gros.
export type KpiCardTone = 'success' | 'attention' | 'neutral';

export interface KpiCardProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  value: ReactNode;
  tone?: KpiCardTone;
}

// Même famille de palette que `PaymentStatusTag`/`StudentFinancialOverview.tsx`
// (`border-green-200 bg-green-50 text-green-700` pour un statut réglé) —
// réutilisée ici plutôt qu'une nouvelle palette inventée pour ce composant.
const TONE_STYLES: Record<KpiCardTone, string> = {
  success: 'ss-kpi-card--success border-green-200 bg-green-50 text-green-700',
  // UX-64 : `border-amber-600`/`bg-amber-100` (valeurs Figma exactes, #D97706/
  // #FEF3C7) — texte `amber-800` (PAS `amber-600` littéral : échoue WCAG AA,
  // 2.86:1 sur amber-100, voir docs/history/UX.md section "UX-64" pour la vérification
  // de contraste complète). `amber-800` sur `amber-100` = 6.37:1, conforme.
  attention: 'ss-kpi-card--attention border-amber-600 bg-amber-100 text-amber-800',
  neutral: 'ss-kpi-card--neutral border-border bg-surface-muted text-text-tertiary',
};

export function KpiCard({ label, value, tone = 'neutral', className, ...rest }: KpiCardProps) {
  const classes = ['ss-kpi-card', 'rounded-md border p-3 text-center', TONE_STYLES[tone], className]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {/* Pas de couleur explicite ici : hérite du `text-*` du conteneur (tone) —
          la VALEUR en revanche reste toujours `text-text`, jamais teintée,
          seul le fond/libellé porte le sens (même principe déjà établi par
          StudentsOverview.tsx, "À traiter"/label coloré, valeur neutre). */}
      <p className="text-xs font-semibold uppercase tracking-wide">{label}</p>
      <p className="mt-1 text-lg font-semibold text-text">{value}</p>
    </div>
  );
}
